import React from 'react';
import { Route, IndexRoute } from 'react-router';
import ActionsDrafts from './actionsDrafts';

export default (
  <Route path="rascunhos">
    <IndexRoute component={(props) => <ActionsDrafts {...props} />} />
  </Route>
);
